<template>
	<view class="container">
		<view class="head">
			<view class="head-top">
				<image src="/static/images/ic_renzhengzhong@2x.png" mode="widthFix"></image>
				<text>平台审核中</text>
			</view>
			<view class="head-bottom">
				审核结果将通过短信/订阅消息通知您
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		.head {
			width: 100%;
			height: 248rpx;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background: rgba(255,114,0,0.08);
			.head-top {
				display: flex;
				align-items: center;
				justify-content: center;
				image {
					width: 60rpx;
					height: 56rpx;
					margin-right: 20rpx;
				}
				text {
					font-weight: 600;
					font-size: 40rpx;
					color: #FA8010;
				}
			}
			.head-bottom {
				font-weight: 400;
				font-size: 28rpx;
				color: #333333;
				margin-top: 34rpx;
			}
		}
	}
</style>